/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

export const SESSION_ROLE_TYPES = {"moderator":0,"required":1,"optional":2};
export const SESSION_ROLE_TYPE_TO_NAME = {
    0: 'Moderator',
    1: 'Required',
    2: 'Optional',
};
export const SESSION_ROLE_TYPE_NAMES = {
  MODERATOR: 'moderator',
  REQUIRED: 'required',
  OPTIONAL: 'optional',
};
